
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vacation-tracker",
      function () {
        return require("private-next-pages/vacation-tracker/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vacation-tracker"])
      });
    }
  